<template>
  <v-container class="main-supplier-select mainWrapElements">
    <img v-if="instance.linktree_logo !== null && instance.linktree_logo.thumb !== undefined" class="mx-auto linktree-logo" :src="instance.linktree_logo.thumb" />
    <div v-else class="layout-img-logo" />
    <div class="scrollMobileFix">
    <v-row class="linktree mainWrapBtns">
      <v-col v-for="item in customerLinktree" :key="item.url != null && item.url != '' ? item.url : item.target" class="wrapBtn">
        <v-btn
          v-if="item.url != '' && item.target === '_blank' || item.target === '_self'"
          class="itemBtn" link large block
          :href="item.url" :target="item.target"
          v-html="item.label"
        />
        <v-btn 
          v-else
          class="itemBtn"
          large block
          @click="execILink(item.target)"
        >
          {{ item.label_custom && item.label_custom !== null && item.label_custom !== '' ? item.label_custom : getLabelTranslation(item) }}
        </v-btn> 
      </v-col>
      <v-col v-if="instance.linktree_add_suppliers" class="wrapBtn">
        <v-btn
          v-if="instance.labels_buttons.nuestras_tiendas !== undefined && instance.labels_buttons.nuestras_tiendas.toString().length > 0"
          class="itemBtn" large block
          @click="goToBranches()"
          v-html="instance.labels_buttons.nuestras_tiendas"
        />
        <v-btn
          v-else
          class="itemBtn" large block
          @click="goToBranches()"
          v-html="$t('common.nuestras_tiendas')"
        />
      </v-col>
      <v-col v-if="instance.slug === 'semolina' || instance.slug === 'patria'" class="py-0 mt-0" cols="12" sm="6" offset-sm="3">
        <v-btn
          class="mt-2" large block
          v-html="$t('contact_us')"
          @click="goToBranchesWhatsapp()"
        />
      </v-col>
    </v-row>
    <set-location v-if="modalGps" @closeModalGps="closeModalGps" />
    <social-networks :instance="instance" />
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { track } from "@/services/track-custom";
import { locationMixins } from "@/mixins/locationMixin.js";

export default {
  name: "Main",
  components: {
    SocialNetworks: () => import(/* webpackChunkName: "SocialNetworks" */'@/components/common/SocialNetworks.vue'),
    SetLocation: () => import(/* webpackChunkName: "SetLocation" */'@/views/delivery/SetLocation.vue')
  },
  data: () => ({
    modalGps: false
  }),
  watch: {
    citysGhost (val) {
      this.oneCityRedirec(val);
    }
  },
  created() {
    this.TemplateDisableHeader();
    this.SetAppClass("background-app");
    this.setService("");
    this.linkInstance();
  },
  computed: {
    ...mapState('customer', ["instance"]),
    ...mapGetters('customer', ['getLabels']),
    customerLinktree() {
      let iLinks = [];
      let cLinks = [];
      for(let i = 0; i < this.instance.linktree.length; i++) {
        let link = this.instance.linktree[i];
        if(link.target === '_blank' || link.target === '_self') {
          cLinks.push(link);
        } else {
          iLinks.push(link);
        }
      }
      iLinks = iLinks.concat(cLinks);
      return iLinks;
    }
  },
  mixins: [ locationMixins ],
  methods: {
    ...mapMutations('template', ['SetLoading', 'TemplateDisableHeader', 'SetAppClass']),
    ...mapMutations('order', ['setService']),
    ...mapMutations('profile', ['setAllowGps']),
    ...mapActions('order', ['setSchedule', 'setDelivery']),
    goToBranchesWhatsapp() {
      this.$router.push({name: "BranchWhatsapp"});
    },
    goToBranches() {
      this.$router.push({name: "Branch"});
    },
    execDelivery() {
      this.setDelivery();
      this.oneSupplierRedirec();
    },
    closeModalGps() {
      if (this.locationChangeCity)  this.modalGps = true;
      else this.modalGps = false;
    },
    execBook() {
      this.$router.push({name: "BranchToBook"});
    },
    execOnTable() {
      this.$router.push({name: "BranchOnTable"});
    },
    execTakeAway() {
      this.$router.push({name: "BranchToTakeAway"});
    },
    execSchedule() {
      this.setSchedule();
      this.oneSupplierRedirec();
    },
    getLabelTranslation(item) {
      switch (item.target) {
        case 'service_schedule':
          return `${this.$t("schedule")} ${this.getLabels('delivery')}`;
        case 'service_table':
          return this.$t("service.select_popup.on_table_title", {category: this.instance.category_establishment});
        case 'service_delivery':
          return this.getLabels('delivery_title');
        case 'service_book':
          return this.$t("service.select_popup.book_title");
        case 'service_take_away':
          return this.$t("service.select_popup.take_away_title", {category: this.instance.category_establishment});
        default:
          return item.label;
      }
    },
    execILink(target) {
      switch (target) {
        case 'service_schedule':
          this.execSchedule();
          break;
        case 'service_table':
          this.execOnTable();
          break;
        case 'service_delivery':
          this.execDelivery();
          break;
        case 'service_book':
          this.execBook();
          break;
        case 'service_take_away':
          this.execTakeAway();
          break;
      }
    },  
    handlePermission() {
      let self = this;
      if (navigator.permissions) {
        navigator.permissions
          .query({name: "geolocation"})
          .then(function (result) {
            self.validateResult(result);
            result.onchange = function () {
              self.validateResult(result);
            };
          });
      }
    },
    validateResult(result) {
      if (result.state === "granted") {
        this.setAllowGps(true);
      }
    },
    closeActiveGps() {
      this.setAllowGps(true);
    },
    linkInstance() {
      try {
        if (this.instance.links.length === 1) {
          let link = this.instance.links[0];
          if (link.type === "on_table") this.execOnTable();
        };
      } catch (error) {
        error;
      };
    },
    goToHomeDelivery() {
      this.$router.push({
        name: "Home",
        params: { supplier_id: this.supplier.slug }
      });
    },
    oneSupplierRedirec () {
      if (this.instance.suppliers.length !== 1) {
        if (this.citysGhost.length === 0) this.getCitys();
        else this.oneCityRedirec(this.citysGhost);
      } else {
        let supplier_id = this.instance.suppliers[0];
        this.SetSupplier(supplier_id);
        setTimeout(() => this.goToHomeDelivery(), 1000);
      };
    },
    oneCityRedirec (citys) {
      if (citys && citys.length > 1) {
        this.modalGps = true;
      } else if (citys && citys.length === 1) {
        this.city = citys[0];
        this.getInfoSucursal(citys[0].supplier_id);
        setTimeout(() => this.goToHomeDelivery(), 1000);
      } else {
        (citys);
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.SetLoading(false);
    }, process.env.VUE_APP_DELAY);
    track.trackView(this, `Main`, `/`);
    track.trackEventCluvi({}, "view main");
    try {
      this.handlePermission();
    } catch (error) {
      error;
      this.activeGps = true;
    }
  },
  metaInfo() {
    return {
      title: this.instance.name,
      link: [
        {rel: "icon", href: this.instance.meta.favicon},
        {
          rel: "icon",
          href: this.instance.meta.favicon,
          type: "image/png",
          sizes: "32x32"
        }
      ],
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.instance.name
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.main-supplier-select {
  h2,
  h3 {
    text-align: center;
    color: white;
  }

  display: grid;
  min-height: 80vh;
  align-content: center;
  align-items: center;
  text-align: center;
}

.layout-img-logo {
  min-height: 10vh;
}

.linktree-logo {
  max-height: 20vh;
  max-width: 50vw !important;
}
</style>
